module.exports = __webpack_public_path__ + "img/d- (6).142a9fb4.png";